import React from 'react';
import { Form, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./textfield.css";

const TextField = ({
    type,
    id, 
    label,
    placeholder
    
  }: 
  {
    type: string;
    id: string;
    label: string;
    placeholder: string;
    
   
  }) => {
    return (
        <>
            <div className="floating-label-group">
                  <input type={type} id={id} placeholder={placeholder} className="textstyle"/>
                  <label className="floating-label">{label}</label>
            </div>
        </>
    );
}


export default TextField;
